import { Link } from 'react-router-dom';
import useIsMobile from '../../hooks/useIsMobile';

export default function Footer() {
  const isMobile = useIsMobile();

  return (
    <footer style={S.footer}>
      <div style={{ ...S.inner, gridTemplateColumns: isMobile ? '1fr 1fr' : '2fr 1fr 1fr 1fr', padding: isMobile ? '40px 20px 28px' : '56px 56px 40px', gap: isMobile ? '32px' : '48px' }}>
        <div style={{ gridColumn: isMobile ? '1/-1' : undefined }}>
          <img src="/logo-transparent.png" alt="Bhadralok" style={S.logoImg} />
          <p style={S.tagline}>Cha · Adda · Identity</p>
          <p style={S.desc}>Proudly Bengali. Authentically made.</p>
        </div>

        <div style={S.col}>
          <p style={S.colTitle}>Shop</p>
          {[['New Arrivals','/products'],['Kurta','/products'],['T-Shirts','/products'],['Accessories','/products']].map(([l, h]) => (
            <Link key={l} to={h} style={S.colLink}>{l}</Link>
          ))}
        </div>

        <div style={S.col}>
          <p style={S.colTitle}>Help</p>
          {[['Track Order','/track-order'],['Returns','/returns'],['Size Guide','/size-guide'],['FAQs','/faqs']].map(([l, h]) => (
            <Link key={l} to={h} style={S.colLink}>{l}</Link>
          ))}
        </div>

        <div style={{ ...S.col, gridColumn: isMobile ? '1/-1' : undefined }}>
          <p style={S.colTitle}>Company</p>
          {[['About','/about'],['Adda (Blog)','/adda'],['Privacy Policy','/privacy-policy'],['Terms of Use','/terms-of-use']].map(([l, h]) => (
            <Link key={l} to={h} style={S.colLink}>{l}</Link>
          ))}
        </div>
      </div>

      <div style={{ ...S.bottom, flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : 0, padding: isMobile ? '16px 20px' : '20px 56px', textAlign: isMobile ? 'center' : 'left' }}>
        <p style={{ margin: 0, color: 'rgba(255,255,255,.3)', fontSize: '12px' }}>
          © 2026 Bhadralok. All rights reserved.
        </p>
        <div style={{ display: 'flex', gap: '20px' }}>
          {['Instagram', 'Facebook', 'Twitter'].map((s) => (
            <span key={s} style={S.social}>{s}</span>
          ))}
        </div>
      </div>
    </footer>
  );
}

const S = {
  footer:  { background: 'var(--black)', borderTop: '3px solid var(--red)', marginTop: 'auto' },
  inner:   { display: 'grid', maxWidth: '1400px', margin: '0 auto' },
  logoImg: { height: '38px', width: 'auto', display: 'block', marginBottom: '12px', background: '#fff', padding: '5px 10px' },
  tagline: { fontFamily: 'var(--font-script)', fontSize: '18px', color: 'var(--gold)', margin: '8px 0 6px' },
  desc:    { fontSize: '13px', color: 'rgba(255,255,255,.4)', lineHeight: 1.6 },
  col:     { display: 'flex', flexDirection: 'column', gap: '10px' },
  colTitle:{ fontFamily: 'var(--font-display)', fontSize: '14px', letterSpacing: '2px', color: '#fff', marginBottom: '4px' },
  colLink: { color: 'rgba(255,255,255,.45)', fontSize: '13px', transition: 'color .2s' },
  bottom:  { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid rgba(255,255,255,.08)', maxWidth: '1400px', margin: '0 auto', width: '100%' },
  social:  { color: 'rgba(255,255,255,.35)', fontSize: '12px', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer' },
};
